export const SAUDI_ARABIA = 682;

// export const TAP_ACTIVE_COUNTRY = {682: 'Saudi Arabia', 818: 'Egypt', 784: 'United Arab Emirates'};
export const TAP_ACTIVE_COUNTRY = ['682', '818', '784'];

export const PAYPAL_SUPPORTED_COUNTRY = [
	840, // United States
	826, // United Kingdom
	124, // Canada
	276, // Germany
	250, // France
	36, // Australia
	76, // Brazil
	380, // Italy
	724, // Spain
	643, // Russia
	682, // Saudi Arabia
	608, // Philippines
];

export const STRIPE_SUPPORTED_COUNTRY = [
	840, // United States
	826, // United Kingdom
	124, // Canada
	276, // Germany
	250, // France
	36, // Australia
	380, // Italy
	724, // Spain
	356, // India
	528, // Netherlands
	784, // UAE
];

export const OPAY_SUPPORTED_COUNTRY = [818, 784, 682, 634, 586];

export const CITY = {
	JEDDAH: 18
}